import React from "react";
import ReactSelect from "react-select";

export const Select: React.FC<any> = ({ handleChange, options, value }) => (
  <ReactSelect onChange={handleChange} options={options} value={value} />
);
